export const STAR_RATING_ISSUE_TYPES = [
  { key: 'didnt_follow_instructions', label: "Didn't follow instructions" },
  { key: 'misrepresented_brand', label: 'Misrepresented brand product/services' },
  { key: 'too_generic', label: 'Too generic / not personalized' },
  { key: 'bad_layout', label: 'Bad layout or composition' },
  { key: 'wrong_colors_fonts', label: 'Wrong colors or fonts' },
  { key: 'wrong_tone', label: 'Wrong tone or voice' },
  { key: 'hard_to_read', label: 'Text is hard to read' },
  { key: 'image_mismatch', label: "Image doesn't match content" },
  { key: 'wrong_length', label: 'Too long or too short' },
  { key: 'factually_incorrect', label: 'Factually incorrect' },
  { key: 'unnatural_language', label: 'Awkward or unnatural language' },
  { key: 'other', label: 'Other (please comment)' },
] as const

export type IssueTypeKey = (typeof STAR_RATING_ISSUE_TYPES)[number]['key']
